import { Box, Stack, Typography, OutlinedInput, Grid, MenuItem, Select, Grid2 } from "@mui/material";
import { FC, useState } from "react";
import { thumbnailService, userService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import MovieCard from "../MovieCard/movie-card";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import TableSkeleton from "../../Table/TableSkeleton";
import { useTranslation } from "react-i18next";

type DTOshCard = {
  jsx: any;
  name: string;
};

const CouldLikeCard: FC = (props) => {
  const { t } = useTranslation();
  const [searchHistory, setSearchHistory] = useState<DTOshCard[]>([]);
  const [sort, SetSort] = useState<string>("");
  const [loading, SetLoading] = useState<boolean>(false);
  const [sortSearch, SetSortSearch] = useState<string>("");

  React.useEffect(() => {
    // Get "You could also like"
    SetLoading(true);
    userService.GetSearchHistory().then(function (response) {
      SetLoading(false);
      if (response.searchHistory !== null)
        setSearchHistory(
          response.searchHistory
            .filter((x) => x.layer === ObjectLayer.Title)
            .map<DTOshCard>((movie, index) => {
              return {
                jsx: (
                  <Grid2 key={index} size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
                    <MovieCard
                      key={movie.objectId}
                      title={movie.description!}
                      id={movie.objectId!}
                      cover={thumbnailService.GetObjectPosterUrl(movie.objectId!, ThumbnailSize.small)}
                      transparentChipText={"#" + movie.objectId!}
                      labelList={[]}
                      favorite={false}
                      expand={{ tagList: [], contentList: [], audioList: [], subtitleList: [], quality: "" }}
                      //   noHover={true}
                    />
                  </Grid2>
                ),
                name: movie.description!,
              };
            })
        );
    });
  }, []);

  const children = React.useMemo(() => {
    return searchHistory.filter((x) => x.name.includesAllWords(sortSearch)).flatMap((x) => x.jsx);
  }, [searchHistory, sort, sortSearch]);

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight={600}>
          {t("card:couldLikeCard.body.youCouldAlsoLike")}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <OutlinedInput
            label={t("common:standard")}
            size="small"
            sx={{ width: 240 }}
            placeholder={t("common:search")}
            value={sortSearch}
            onChange={(value) => SetSortSearch(value.target.value)}
            endAdornment={<SearchIcon htmlColor="text.primary" />}
          />

          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={sort}
            onChange={(value) => SetSort(value.target.value)}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
          >
            <MenuItem value="">{t("menu:item.sortBy")}</MenuItem>
            <MenuItem value="name">{t("common:title")}</MenuItem>
            <MenuItem value="date">{t("common:recent")}</MenuItem>
          </Select>
        </Stack>
      </Stack>
      {loading ? (
        <TableSkeleton />
      ) : (
        <Grid2 container columns={24} spacing={2}>
          {children}
        </Grid2>
      )}
    </Box>
  );
};

export default CouldLikeCard;
